export default {
      id: "eld_battery-usage",
      viewBox: "0 0 48 29",
      url: __webpack_public_path__ + "img/icons.svg#eld_battery",
      toString: function () {
        return this.url;
      }
    }